export const HALF_LIFE_LIST = 'HALF_LIFE_LIST';
export const EVENT_COND_CRUD = 'EVENT_COND_CRUD';
export const EVENT_VIEW = 'EVENT_VIEW';
export const HALF_LIFE_MAINT_LOADER = 'HALF_LIFE_MAINT_LOADER';
export const EXPORT_HALF_LIFE_MAINT = 'EXPORT_HALF_LIFE_MAINT';